import { render } from "./CharlaStatistics.vue?vue&type=template&id=3fa7aceb&scoped=true"
import script from "./CharlaStatistics.vue?vue&type=script&lang=js"
export * from "./CharlaStatistics.vue?vue&type=script&lang=js"

import "./CharlaStatistics.vue?vue&type=style&index=0&id=3fa7aceb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa7aceb"]])

export default __exports__